export default "__VITE_ASSET__DfLGhVL9__"